//
//
//
//
//
//

export default {
  name: 'hello'
}



// WEBPACK FOOTER //
// ./src/components/Hello.vue